"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.form.title': 'Logowanie',
    'login.form.hero.title': 'Witaj ponownie',
    'login.form.hero.description': 'Użyj swoich danych logowania.',
    'login.form.hero.register_link_text': 'Jeśli nie jesteś członkiem, proszę',
    'login.form.hero.register_link': 'zarejestruj się tutaj',
};
